import React, { useEffect } from 'react'
import Progress from './Progress'
import appconstant from '../../../themes/appconstant';
import { useDispatch, useSelector } from 'react-redux';
import { toolsTopUsageLoad } from '../../../redux/slices/tools.slice';

const ProgressChart = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toolsTopUsageLoad());
  }, []);

  const chartData = useSelector((state) => state.toolsReducer);
  const topUsageData = chartData.topUsageData[0]
  const total = topUsageData?.logMood + topUsageData?.community + topUsageData?.journaling + topUsageData?.affirmation + topUsageData?.logThoughts
  const logMoodPer = ((topUsageData?.logMood / total) * 100) || 0;
  const logThoughtsPer = ((topUsageData?.logThoughts / total) * 100) || 0;
  const communityPer = ((topUsageData?.community / total) * 100) || 0;
  const journalingPer = ((topUsageData?.journaling / total) * 100) || 0;
  const affirmationPer = ((topUsageData?.affirmation / total) * 100) || 0;
  return (

    <div className='p-7 w-full'>
      <Progress label={appconstant?.logmood} value={topUsageData?.logMood} width={`${logMoodPer}%`} />
      <Progress label={appconstant?.logthought} value={topUsageData?.logThoughts} width={`${logThoughtsPer}%`} />
      <Progress label={appconstant?.community} value={topUsageData?.community} width={`${communityPer}%`} />
      <Progress label={appconstant?.journaling} value={topUsageData?.journaling} width={`${journalingPer}%`} />
      <Progress label={appconstant?.affirmation} value={topUsageData?.journaling} width={`${affirmationPer}%`} />
    </div>



  )
}

export default ProgressChart;